/**
 * Keys we have retired. They should not exist in any environment.
 *
 * Reported only when an environment still HAS one — the bucket is
 * "deprecated and still registered here", so the normal state of this list is
 * to produce nothing, which is why the page hides that tab at zero.
 *
 * `retiredIn` names the PR or release that removed the last reader, so an
 * operator can tell "retired last week, some orgs may still be on the old
 * build" from "retired two years ago".
 */

import { ManifestDeprecatedEntry } from '@redact-modules/admin/models';

export const DEPRECATED_ENTRIES: readonly ManifestDeprecatedEntry[] = [
  // Empty. `numberOfDaysBeforeToDelete` was the last entry and has been dropped
  // entirely: it was renamed to `trashRetentionDays` long enough ago that no
  // supported environment still carries it, and a deprecated entry only earns
  // its place while some environment might still have the key registered.
  //
  // Unlike the `optional` list that was deleted outright, this one stays. The
  // claim it makes — "retired; it should not exist anywhere" — is one we will
  // make again the next time a key is retired, and it is the only list whose
  // presence turns a key that would otherwise read as Unrecognized (behind a
  // typed-key Delete permanently) into a simple, explained cleanup.
];
